export default "__VITE_ASSET__6773c319__"